<script src="./index.js"></script>
<style src="./style.scss" lang="scss" scoped/>
<template>
    <div v-bind:class="{
    'marketplace-adv': true,
    'label-discount': labeldiscount === 'yes',
  }">
        <div class="marketplace-ad-container" v-bind:class="{'vip-ad': isVip}">
            <div class="d-flex gap-4">
                <div class="d-flex justify-content-center align-items-center">
                    <router-link :to="{name: 'SinglePropertyPage', params: {id: id}}" class="marketplace-ad-title">
                        <div class="image-container" v-bind:style="{'background-image': 'url(' + $imageUrl(image) + ')'}"></div>
                    </router-link>
                </div>
                <div>
                    <div class="marketplace-ad-text">
                        <router-link :to="{name: 'SinglePropertyPage', params: {id: id}}" class="marketplace-ad-title">
                            {{ title }}
                        </router-link>
                    </div>
                    <div class="marketplace-price-tag mt-auto">
                        <div class="old-price" v-if="discountedamount && discountedamount > 0">
                            <div class="price-amount">
                                {{ toCurrency(regularamount) }} {{ $t('eur') }}
                            </div>
                        </div>
                        <div class="discounted-price" v-if="discountedamount && discountedamount > 0">
                            <div class="price-amount">
                                {{ toCurrency(discountedamount) }} {{ $t('eur') }}
                            </div>
                        </div>
                        <div class="regular-price pt-3" v-else>
                            <div class="price-amount">
                                {{ toCurrency(regularamount) }} {{ $t('eur') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
